module.exports = __webpack_public_path__ + "static/img/logo2.d837cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/score/logo2.png
// module id = 44
// module chunks = 0